
import { BILLING_MANAGEMENT_DETAIL, BILLING_MANAGEMENT_LIST } from "../Constants/BillingConstants";
import { createGetDataReducer } from "./CommonReducer";

const BillingManagementListReducer = createGetDataReducer(BILLING_MANAGEMENT_LIST);
const BillingManagementDetailReducer = createGetDataReducer(BILLING_MANAGEMENT_DETAIL);

export const BillingManagementReducer = {
   BillingManagementListState: BillingManagementListReducer,
   BillingManagementDetailState:BillingManagementDetailReducer
}